(function() { window.GUID_8498e2e1_920c_4712_97dd_ec7a76900266 = { getGuid: function() { return "8498e2e1-920c-4712-97dd-ec7a76900266"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Gallery {
            static GalItemClick($element, e) {
                e.stopImmediatePropagation();
                var gallery = $element.data('gallery');
                let galleryData = JSON.stringify(gallery);
                let url = gallery.ShowGalleryUrl;
                if (url.indexOf("?") > -1) {
                    url = url + "&galleryData=" + galleryData;
                }
                else {
                    url = url + "?galleryData=" + galleryData;
                }
                CS.Nav.Go(url);
            }
        }
        Controls.Gallery = Gallery;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=gallery.js.map
